import React, {useState} from "react";
import GenericDialog from "../../../../../ui/dialogs/generic-dialog/GenericDialog";
import ButtonIconLeft from "../../../../../ui/buttons/button-icon-left/ButtonIconLeft";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import Typography from "@material-ui/core/Typography";
import GrayHeaderCard from "../../../../../ui/cards/gray-header-card/GrayHeaderCard";
import {Paper} from "@material-ui/core";
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import IconButton from "@material-ui/core/IconButton";
import {makeStyles} from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import {theme} from "../../../../../../shared/theme";
import LimitedCharactersDialog
    from "../../../../../../shared/components/dialogs/limited-characters-dialog/LimitedCharactersDialog";
import RichiediModificaDelleFattureDialog
    from "../RichiediModificaDelleFattureDialog/RichiediModificaDelleFattureDialog";
import RichiediModificaDeiConsensiPrivacyDialog
    from "../RichiediModificaDeiConsensiPrivacyDialog/RichiediModificaDeiConsensiPrivacyDialog";

import ImpostazioniAPNDialog from "../../../sim/Dialogs/impostazioni-apn-dialog/ImpostazioniAPNDialog";
import DeviceAssistenzaDialog
    from "../../../../../../shared/components/dialogs/device-assistenza-dialog/DeviceAssistenzaDialog";
import {useSelector} from "react-redux";

const useStyles = makeStyles({
    iconButton: {
        border: "1px solid",
    },
    paper: {
        borderRadius: "8px",
        display: "inline-flex",
        width: "100%",
        padding: theme.spacing(2),
        '& > .MuiTypography-root': {
            flexGrow: 1
        }
    },
    titleClasses: {
        '& > *': {
            marginBottom: "2em"
        }
    }
})

const RichiediUnaModificaDialog = (props) => {
    const classes = useStyles();

    const dedicatedType = true;
    const [openRichiediModificaDelleFattureDialog, setOpenRichiediModificaDelleFatureDialog] = useState(false);
    const [openImpostazioniAPNDialog, setOpenImpostazioniAPNDialog] = useState(false);
    const [screenCode, setScreenCode] = useState(null);
    const [openRichiediAssistenzaDeviceDialog, setOpenRichiediAssistenzaDeviceDialog] = useState(null);
    const [impostazioniAPNDialogData, setImpostazioniAPNDialogData] = useState({
        title: "",
        selectLabel: "",
        selectPlaceholder: "",
        subtitle: ""
    });
    const [openLimitedCharactersDialog, setOpenLimitedCharactersDialog] = useState({
        open: false,
        title: "",
        subtitle: "",
    });

    const [openRichiediModificaDeiConsensiPrivacyDialog, setOpenRichiediModificaDeiConsensiPrivacyDialog] = useState(false);

    const showEpic64 = useSelector(state => state.authReducer.frontendConfiguration.ep64) === "1";

    const handleOpenDialog = (dialogType, title = "", subtitle = "", screenCode = "", selectLabel = "", selectPlaceholder = "") => {
        /**
         * dialogType = 1 -----> limited-characters-dialog
         * dialogType = 2 -----> RichiediModificaDelleFattureDialog
         * dialogType = 3 -----> RichiediModificaDeiConsensiPrivacyDialog
         * dialogType = 4 -----> impostazioni-apn-dialog
         */
        if (dialogType === 1) {
            setScreenCode(screenCode);
            setOpenLimitedCharactersDialog({
                open: true,
                title: title,
                subtitle: subtitle,
            });
        }
        if (dialogType === 2) {
            setOpenRichiediModificaDelleFatureDialog(true);
            setScreenCode(screenCode);
        }
        if (dialogType === 3) {
            setOpenRichiediModificaDeiConsensiPrivacyDialog(true);
        }
        if (dialogType === 4) {
            setScreenCode(screenCode)
            setImpostazioniAPNDialogData({
                title: title,
                selectLabel: selectLabel,
                selectPlaceholder: selectPlaceholder,
                subtitle: subtitle
            })
            setOpenImpostazioniAPNDialog(true);
        }
    }

    const modificheAmministrativeItems = [
        {
            text: "Ragione sociale",
            handleClick: () => {
                handleOpenDialog(
                    1,
                    "Richiedi modifica della ragione sociale",
                    "Specifica il più possibile il dettaglio della tua richiesta. Sarai contattato quanto prima dal Servizio Clienti per dare seguito alla tua richiesta.",
                    "E5.01.C.02")
            },
        },
        {
            text: "Impostazioni fatture",
            handleClick: () => {
                handleOpenDialog(
                    1,
                    "Richiedi la modifica delle impostazioni fatture",
                    "Puoi richiedere la modifica del layout delle fatture, la periodicità, i codici FEPR e FEPA. Specifica il più possibile il dettaglio della tua richiesta. Sarai contattato quanto prima dal Servizio Clienti per dare seguito alla tua richiesta.",
                    "E5.01.C.08")
            }
        },
        {
            text: "Sede legale",
            handleClick: () => {
                handleOpenDialog(
                    1,
                    "Richiedi modifica della sede legale",
                    "Specifica il più possibile il dettaglio della tua richiesta. Sarai contattato quanto prima dal Servizio Clienti per dare seguito alla tua richiesta.",
                    "E5.01.C.03")
            }
        },
        {
            text: "Indirizzo di spedizione delle fatture",
            handleClick: () => {
                handleOpenDialog(2, "", "", "E5.01.C.09", "", "")
            }
        },
        {
            text: "Anagrafica azienda",
            handleClick: () => {
                handleOpenDialog(
                    1,
                    "Richiedi modifica dell’anagrafica azienda",
                    "Specifica il più possibile il dettaglio della tua richiesta. Sarai contattato quanto prima dal Servizio Clienti per dare seguito alla tua richiesta.",
                    "E5.01.C.02")
            }
        },
        // {
        //     text: "Variazione centro di fatturazione o di costo",
        //     handleClick: () => {}
        // },
        // {
        //     text: "Consensi privacy",
        //     handleClick: () => {handleOpenDialog(3,"","")}
        // },
        //Hide the modal at the moment
        {
            text: "Nuovo centro di fatturazione",
            handleClick: () => {
                handleOpenDialog(
                    1,
                    "Richiedi la creazione di un nuovo centro di fatturazione",
                    "Specifica il più possibile il dettaglio della tua richiesta. Sarai contattato quanto prima dal Servizio Clienti per dare seguito alla tua richiesta.",
                    "E5.01.C.11")
            }
        },
        {
            text: "Subentro",
            handleClick: () => {
                handleOpenDialog(
                    1,
                    "Richiedi il subentro",
                    "Specifica il più possibile il dettaglio della tua richiesta. Sarai contattato quanto prima dal Servizio Clienti per dare seguito alla tua richiesta.",
                    "E5.01.C.10")
            }
        },
        {
            text: "Nuovo centro di costo",
            handleClick: () => {
                handleOpenDialog(
                    1,
                    "Richiedi la creazione di un nuovo centro di costo",
                    "Specifica il più possibile il dettaglio della tua richiesta. Sarai contattato quanto prima dal Servizio Clienti per dare seguito alla tua richiesta.",
                    "E5.01.C.12")
            }
        },
        {
            text: "Metodo di pagamento",
            handleClick: () => {
                handleOpenDialog(
                    1,
                    "Richiedi modifica del metodo di pagamento",
                    "Specifica il più possibile il dettaglio della tua richiesta. Sarai contattato quanto prima dal Servizio Clienti per dare seguito alla tua richiesta.",
                    "E5.01.C.07")
            }
        },
        ...showEpic64 ?
            [
                {
                    text: "Data di rinnovo SIM",
                    handleClick: () => {
                        handleOpenDialog(
                            1,
                            "Richiedi la modifica della data di rinnovo dei piani SIM",
                            "Puoi richiedere la modifica dei piani di rinnovo delle SIM al primo del mese. " +
                            "Specifica il più possibile il dettaglio della tua richiesta. Sarai contattato quanto prima dal Servizio Clienti per dare seguito alla tua richiesta.",
                            "E64.01.02")
                    }
                }
            ] : [],
        {
            text: "Altro",
            handleClick: () => {
                handleOpenDialog(
                    1,
                    "Altro",
                    "Specifica il più possibile il dettaglio della tua richiesta. Sarai contattato quanto prima dal Servizio Clienti per dare seguito alla tua richiesta.",
                    "E5.01.C.15")
            }
        }
    ];

    const simModificheCommericaliItems = [
        {
            text: "Nuovo gruppo RAM",
            handleClick: () => {
                handleOpenDialog(
                    1,
                    "Richiedi la creazione di un nuovo gruppo RAM",
                    "Specifica il più possibile il dettaglio della tua richiesta. Sarai contattato quanto prima dal Servizio Clienti per dare seguito alla tua richiesta.",
                    "E5.01.C.13")
            },
        },
    ];

    const deviceModificheCommericaliItems = [
        {
            text: "Assistenza",
            handleClick: () => {
                setOpenRichiediAssistenzaDeviceDialog(true)
            },
        },
    ];

    const modificheTechincheItems = [
        {
            text: "Impostazioni APN",
            handleClick: () => {
                handleOpenDialog(
                    4,
                    "Richiedi modifica delle impostazioni APN",
                    "Specifica il più possibile il dettaglio della tua richiesta. Sarai contattato quanto prima dal Servizio Clienti per dare seguito alla tua richiesta.",
                    "E5.01.C.14",
                    "Categoria",
                    "Seleziona la categoria")
            },
        },
    ];

    const dialogContent = (
        <React.Fragment>
            <GrayHeaderCard title={<Typography variant="subtitle1">Modifiche amministrative</Typography>}>
                <Grid container spacing={2}>
                    {modificheAmministrativeItems.map((item, index) => (
                        <Grid key={index} item xs={12} sm={12} md={6} lg={6}>
                            <Paper className={classes.paper} elevation={6}>
                                <Typography noWrap variant={"h6"}>{item.text}</Typography>
                                <IconButton onClick={item.handleClick} size={"small"} color={"secondary"}
                                            className={classes.iconButton}>
                                    <ChevronRightIcon/>
                                </IconButton>
                            </Paper>
                        </Grid>
                    ))}
                </Grid>

            </GrayHeaderCard>
            <GrayHeaderCard title={<Typography variant="subtitle1">Device - Modifiche commerciali</Typography>}>
                <Grid container spacing={2}>
                    {deviceModificheCommericaliItems.map((item, index) => (
                        <Grid key={index} item xs={12} sm={12} md={6} lg={6}>
                            <Paper className={classes.paper} elevation={6}>
                                <Typography variant={"h6"}>{item.text}</Typography>
                                <IconButton onClick={item.handleClick} size={"small"} color={"secondary"}
                                            className={classes.iconButton}>
                                    <ChevronRightIcon/>
                                </IconButton>
                            </Paper>
                        </Grid>
                    ))}
                </Grid>
            </GrayHeaderCard>
            <GrayHeaderCard title={<Typography variant="subtitle1">SIM - Modifiche commerciali</Typography>}>
                <Grid container spacing={2}>
                    {simModificheCommericaliItems.map((item, index) => (
                        <Grid key={index} item xs={12} sm={12} md={6} lg={6}>
                            <Paper className={classes.paper} elevation={6}>
                                <Typography variant={"h6"}>{item.text}</Typography>
                                <IconButton onClick={item.handleClick} size={"small"} color={"secondary"}
                                            className={classes.iconButton}>
                                    <ChevronRightIcon/>
                                </IconButton>
                            </Paper>
                        </Grid>
                    ))}
                </Grid>
            </GrayHeaderCard>
            {dedicatedType ?
                <GrayHeaderCard title={<Typography variant="subtitle1">SIM - Modifiche tecniche</Typography>}>
                    <Grid container spacing={2}>
                        {modificheTechincheItems.map((item, index) => (
                            <Grid key={index} item xs={12} sm={12} md={6} lg={6}>
                                <Paper className={classes.paper} elevation={6}>
                                    <Typography variant={"h6"}>{item.text}</Typography>
                                    <IconButton onClick={item.handleClick} size={"small"} color={"secondary"}
                                                className={classes.iconButton}>
                                        <ChevronRightIcon/>
                                    </IconButton>
                                </Paper>
                            </Grid>
                        ))}
                    </Grid>
                </GrayHeaderCard> : null}
            {openLimitedCharactersDialog ? (
                <LimitedCharactersDialog
                    open={openLimitedCharactersDialog.open}
                    characterLimit={1000}
                    screenCode={screenCode}
                    handleDialogClose={() => setOpenLimitedCharactersDialog({
                        ...openLimitedCharactersDialog,
                        open: false
                    })}
                    handleDialogCloseButton={() => setOpenLimitedCharactersDialog({
                        ...openLimitedCharactersDialog,
                        open: false
                    })}
                    title={openLimitedCharactersDialog.title}
                    subtitle={openLimitedCharactersDialog.subtitle}
                    handleConfirmButtonClicked={() => setOpenLimitedCharactersDialog({
                        ...openLimitedCharactersDialog,
                        open: false
                    })}
                />
            ) : null}
            {openRichiediModificaDelleFattureDialog ? (
                <RichiediModificaDelleFattureDialog
                    open={openRichiediModificaDelleFattureDialog}
                    screenCode={screenCode}
                    handleDialogClose={() => setOpenRichiediModificaDelleFatureDialog(false)}
                    handleDialogCloseButton={() => setOpenRichiediModificaDelleFatureDialog(false)}
                    handleConfirmButtonClicked={() => setOpenRichiediModificaDelleFatureDialog(false)}
                />
            ) : null}
            {openImpostazioniAPNDialog ? (
                <ImpostazioniAPNDialog
                    open={openImpostazioniAPNDialog}
                    characterLimit={1000}
                    data={impostazioniAPNDialogData}
                    screenCode={screenCode}
                    handleDialogClose={() => setOpenImpostazioniAPNDialog(false)}
                    handleDialogCloseButton={() => setOpenImpostazioniAPNDialog(false)}
                    handleConfirmButtonClicked={() => setOpenImpostazioniAPNDialog(false)}
                />
            ) : null}
            {openRichiediModificaDeiConsensiPrivacyDialog ? (
                <RichiediModificaDeiConsensiPrivacyDialog
                    open={openRichiediModificaDeiConsensiPrivacyDialog}
                    handleDialogClose={() => setOpenRichiediModificaDeiConsensiPrivacyDialog(false)}
                    handleDialogCloseButton={() => setOpenRichiediModificaDeiConsensiPrivacyDialog(false)}
                    handleConfirmButtonClicked={() => setOpenRichiediModificaDeiConsensiPrivacyDialog(false)}
                />
            ) : null}
            {openRichiediAssistenzaDeviceDialog ? <DeviceAssistenzaDialog
                    open={openRichiediAssistenzaDeviceDialog}
                    handleDialogClose={() => setOpenRichiediAssistenzaDeviceDialog(false)}/>
                : null}
        </React.Fragment>
    );

    const dialogActions = (
        <React.Fragment/>
    );

    return (
        <GenericDialog
            dialogWidth="lg"
            open={props.open}
            handleDialogClose={props.handleDialogClose}
            handleDialogCloseButton={props.handleRichiediUnaModificaCloseButton}
            dialogActions={dialogActions}
            dialogContent={dialogContent}
        >
            <div className={classes.titleClasses}>
                <ButtonIconLeft
                    title={"Indietro"}
                    handleClick={props.handleDialogClose}
                    icon={<ArrowBackIosIcon fontSize="small"/>}/>
                <Typography variant={"h5"}>Richiedi una modifica</Typography>
            </div>
        </GenericDialog>
    )


}

export default RichiediUnaModificaDialog;
